import React from 'react';
import classNames from 'classnames';

import { TextareaProps } from 'atomic/textarea/textarea.interface';

import './textarea.scss';

let textareaId = 0;

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(({
    value,
    label,
    small = false,
    name,
    disabled,
    error,
    onChange
}, ref) => {
    const idx = textareaId++;

    return (
        <div className="form-textarea">
            <textarea
                ref={ref}
                id={idx.toString()}
                name={name}
                className={classNames(
                    {
                        'textarea': true,
                        'textarea--small': Boolean(small),
                        'textarea--disabled': Boolean(disabled),
                        'textarea--error': Boolean(error)
                    }
                )}
                disabled={disabled}
                value={value}
                placeholder={label}
                onChange={onChange}
            />
            { error && (
                <span className="textarea-error-message">
                    Błąd:
                    {'  '}
                    {error}
                </span>
            )}
        </div>
    );
});

Textarea.displayName = 'TextArea';

export default Textarea;
